import styled from 'styled-components'

import { mainColors, semanticColors } from '../../../../styles/colors'
import { _2XL_Bold, _L_Normal } from '../../../../styles/typography'

export const confirmationModalCheckboxClassName = 'confirmation-modal-checkbox'

export const LimitWarning = styled.div`
  ${_L_Normal};
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px;
  border-radius: 4px;
  color: ${semanticColors.warningExtraDark};
  background-color: ${semanticColors.warningLightMedium};

  > svg {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
  }
`

export const DataRequestLink = styled.a`
  color: ${mainColors.accentDark};
  font-weight: bold;
  text-decoration: underline;
`

export const ModalContainer = styled.form`
  width: 480px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
`

export const ModalHeader = styled.header`
  height: 30px;
  display: flex;
  align-items: center;

  ${_2XL_Bold}
`

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  p:first-of-type {
    ${_L_Normal};

    margin-bottom: 16px;
  }

  p:last-of-type {
    margin-bottom: 4px;
  }
`

export const ModalFooter = styled.footer`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;

  button {
    width: max-content;
  }
`

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;

  .${confirmationModalCheckboxClassName} {
    height: max-content;
  }
`
